export default import.meta.ROLLDOWN_FILE_URL_fcn1zEYvoumSGXGdCf_71g